import { Icon } from '@chakra-ui/react';

export default function SFListAddIcon(props) {
  return (
    <Icon
      width={5}
      height={5}
      viewBox='0 0 20 20'
      fill='currentColor'
      xmlns='http://www.w3.org/2000/svg'
      {...props}
    >
      <path
        d='M10.8833 7.86666H3.71666C3.3225 7.86666 3 8.18916 3 8.58332C3 8.97749 3.3225 9.29999 3.71666 9.29999H10.8833C11.2775 9.29999 11.6 8.97749 11.6 8.58332C11.6 8.18916 11.2775 7.86666 10.8833 7.86666ZM10.8833 5H3.71666C3.3225 5 3 5.3225 3 5.71666C3 6.11083 3.3225 6.43333 3.71666 6.43333H10.8833C11.2775 6.43333 11.6 6.11083 11.6 5.71666C11.6 5.3225 11.2775 5 10.8833 5ZM14.4666 10.7333V8.58332C14.4666 8.18916 14.1441 7.86666 13.75 7.86666C13.3558 7.86666 13.0333 8.18916 13.0333 8.58332V10.7333H10.8833C10.4891 10.7333 10.1666 11.0558 10.1666 11.45C10.1666 11.8441 10.4891 12.1666 10.8833 12.1666H13.0333V14.3166C13.0333 14.7108 13.3558 15.0333 13.75 15.0333C14.1441 15.0333 14.4666 14.7108 14.4666 14.3166V12.1666H16.6166C17.0108 12.1666 17.3333 11.8441 17.3333 11.45C17.3333 11.0558 17.0108 10.7333 16.6166 10.7333H14.4666ZM3.71666 12.1666H8.01665C8.41082 12.1666 8.73332 11.8441 8.73332 11.45C8.73332 11.0558 8.41082 10.7333 8.01665 10.7333H3.71666C3.3225 10.7333 3 11.0558 3 11.45C3 11.8441 3.3225 12.1666 3.71666 12.1666Z'
        fill='currentColor'
      />
    </Icon>
  );
}
